// The design picker. Uploads straight to S3 through the existing admin file endpoint and hands
// back the URL — the pop-up stores a URL, never a data URI, because the app has to fetch it too.
import React, { useRef, useState } from 'react';
import { fileUpload } from '../../api/upload';
import { useNotification } from '../../hooks/useNotification';
import CloseButton from './CloseButton';

const ImageField = ({ value, onChange, hint }) => {
  const input = useRef(null);
  const [uploading, setUploading] = useState(false);
  const { showErrorNotification } = useNotification();

  const pick = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const uploaded = await fileUpload(file);
      onChange(uploaded?.url || '');
    } catch (error) {
      console.error('popups: upload', error);
      showErrorNotification('Could not upload the design');
    } finally {
      setUploading(false);
      // Cleared so re-picking the same file still fires a change.
      if (input.current) input.current.value = '';
    }
  };

  return (
    <div className="img-row">
      <button type="button" className="img-btn" disabled={uploading} onClick={() => input.current?.click()}>
        {uploading ? 'Uploading…' : value ? 'Change design' : '+ Upload design'}
      </button>
      {value && (
        <span className="img-thumb">
          <img src={value} alt="" />
          <CloseButton size={20} className="img-x" label="Remove design" onClick={() => onChange('')} />
        </span>
      )}
      <span className="img-hint">{hint}</span>
      <input type="file" ref={input} accept="image/*" hidden onChange={pick} />
    </div>
  );
};

export default ImageField;
